import React from "react";
import { useStateContext, currentMode } from "../../contexts/ContextProvider";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { Row, Col, Button, Alert, Modal } from "react-bootstrap";

const AddAwsAccount = ({
  showForm,
  closeModel,
  getInitialValues,
  validationSchema,
  handleFormSubmit,
  selectedAccount,
}) => {
  const { currentColor, currentMode } = useStateContext();
  return (
    <Modal
      show={showForm}
      onHide={() => {
        closeModel();
      }}
      size="xxxl-down"
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-90w"
      className="modal-90w "
      style={{ width: "50%", left: "25%" }}
    >
      <Modal.Header
        className={`w-full  ${
          currentMode === "Dark" ? "text-white bg-[#33373E]" : "bg-gray-200"
        }`}
        style={{ borderRadius: "none", width: "100%" }}
      >
        <Modal.Title className="text-md font-semibold w-full">
          <div className="flex mt-0 justify-between items-center">
            <div className="flex items-center" style={{ width: "100%" }}>
              {/* <img
    src="/icons/client-icon.svg"
    alt="icon"
    className="w-10 h-10"
    /> */}
              <span
                style={{
                  mask: `url(/icons/edit-user.svg) center no-repeat`,
                  WebkitMask: `url(/icons/edit-user.svg) center no-repeat`,
                  maskSize: "contain", // Adjust the mask size here
                  WebkitMaskSize: "contain",
                  display: "block",
                  width: "35px",
                  height: "35px",
                  backgroundColor: currentColor,
                  transition: "background-color 0.3s",
                  marginRight: "8px",
                }}
              ></span>
              <h5 className="mt-2">
                {selectedAccount ? "Update AWS Account" : "Add AWS Account"}
              </h5>
            </div>
            <div className="flex justify-end" onClick={closeModel}>
              <span
                style={{
                  mask: `url(/icons/close.svg) center no-repeat`,
                  WebkitMask: `url(/icons/close.svg) center no-repeat`,
                  maskSize: "contain", // Adjust the mask size here
                  WebkitMaskSize: "contain",
                  display: "block",
                  width: "25px",
                  height: "25px",
                  backgroundColor: currentColor,
                  transition: "background-color 0.3s",
                  marginRight: "8px",
                  cursor: "pointer",
                }}
              ></span>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`overflow-auto p-6 ${
          currentMode === "Dark" ? "text-white bg-[#33373E]" : "bg-white border"
        }`}
      >
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleFormSubmit}
          enableReinitialize
        >
          {({ isSubmitting }) => (
            <Form>
              <Row className="mb-0">
                <Col>
                  <div className="custom-form-group">
                    <label
                      htmlFor="formAccountName"
                      className="custom-form-label"
                    >
                      Account Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      id="formAccountName"
                      name="accountName"
                      type="text"
                      className={`form-control custom-form-control border-secondary ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                    />
                    <ErrorMessage
                      name="accountName"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="mb-0">
                <Col>
                  <div className="custom-form-group">
                    <label
                      htmlFor="formAccessKey"
                      className="custom-form-label"
                    >
                      Access Key <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      id="formAccessKey"
                      name="accessKey"
                      type="text"
                      className={`form-control custom-form-control border-secondary ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                    />
                    <ErrorMessage
                      name="accessKey"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="mb-0">
                <Col>
                  <div className="custom-form-group">
                    <label
                      htmlFor="formSecretKey"
                      className="custom-form-label"
                    >
                      Secret Key <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      id="formSecretKey"
                      name="secretKey"
                      type="text"
                      className={`form-control custom-form-control border-secondary ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                    />
                    <ErrorMessage
                      name="secretKey"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </Col>
              </Row>

              <Button
                variant="primary"
                type="submit"
                className="mt-3  custom-form-button text-white"
                style={{ backgroundColor: currentColor }}
                disabled={isSubmitting}
              >
                {selectedAccount ? "Update" : "Add"}
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddAwsAccount;
